// Opt-in cookie/storage drift audit. Activate with ?cookieAudit=1
// Logs unknown cookies/localStorage keys to the console for staff review.

const KNOWN_COOKIES = new Set([
  "_ga", "_gid", "_gat", "__cwsGaLoaded",
  "sb-access-token", "sb-refresh-token",
]);
const KNOWN_COOKIE_PREFIXES = ["_ga_", "sb-", "_gcl_"];

const KNOWN_STORAGE_KEYS = new Set([
  "cws-consent-v1", "cws-lang", "cws-tts-cache-v1",
]);
const KNOWN_STORAGE_PREFIXES = ["sb-", "supabase."];

export function runCookieAudit() {
  if (typeof window === "undefined") return;
  if (!new URLSearchParams(window.location.search).get("cookieAudit")) return;

  const cookies = document.cookie.split(";").map((c) => c.trim().split("=")[0]).filter(Boolean);
  const unknownCookies = cookies.filter(
    (name) => !KNOWN_COOKIES.has(name) && !KNOWN_COOKIE_PREFIXES.some((p) => name.startsWith(p))
  );

  const storageKeys: string[] = [];
  for (let i = 0; i < window.localStorage.length; i++) {
    const k = window.localStorage.key(i);
    if (k) storageKeys.push(k);
  }
  const unknownStorage = storageKeys.filter(
    (k) => !KNOWN_STORAGE_KEYS.has(k) && !KNOWN_STORAGE_PREFIXES.some((p) => k.startsWith(p))
  );

  // eslint-disable-next-line no-console
  console.group("[CWS] Cookie & Storage Audit");
  // eslint-disable-next-line no-console
  console.log("All cookies:", cookies);
  // eslint-disable-next-line no-console
  console.log("Unknown cookies (not in registry):", unknownCookies);
  // eslint-disable-next-line no-console
  console.log("All localStorage keys:", storageKeys);
  // eslint-disable-next-line no-console
  console.log("Unknown localStorage keys:", unknownStorage);
  // eslint-disable-next-line no-console
  console.groupEnd();
}
